import React, { useState, useEffect } from "react";
import "./Payment.css";
//import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import CurrencyFormat from "react-currency-format";
import { getBasketTotal } from "./reducer";
import axios from "./axios";
import { useHistory } from "react-router-dom";
import { db } from "./firebase";
import { useSelector, useDispatch } from "react-redux";
import { selectUser, emptyBasket } from "./redux/cart/cartSlice";

function Payment() {
  console.log("Enter Payment Page");
  //  const [{ basket, user }, dispatch] = useStateValue();
  const { user, basket } = useSelector(selectUser);
  const dispatch = useDispatch();

  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [processing, setProcessing] = useState("");
  const [succeeded, setSucceeded] = useState(false);
  const [clientSecret, setClientSecret] = useState(true);
  const history = useHistory();

  const stripe = useStripe();
  const elements = useElements();
  //whenever basket changes below code set new clientsecret to allow customer to charge amount
  useEffect(() => {
    //generate the special stripe client secret which allows us to charge a customer

    const getClientSecret = async () => {
      const response = await axios({
        method: "post",
        //stripe expects total in currencies in subunits
        url: `/payments/create?total=${getBasketTotal(basket) * 100}`,
      }); //belwo line set the client secret recived by the request in api call
      setClientSecret(response.data.clientSecret);
    };

    getClientSecret();
  }, [basket]);

  console.log("this secret is ", clientSecret);

  const handleSumit = async (event) => {
    event.preventDefault();
    setProcessing(true);
    //below code confirm the payment from stripe using client secret
    const payload = await stripe
      .confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })
      .then(({ paymentIntent }) => {
        console.log("Payment Payload", payload);
        // here paymentIntent gives payment confirmation

        //below code is to add order database of user in firestore by creating in it
        db.collection("users")
          .doc(user?.uid)
          .collection("orders")
          .doc(paymentIntent.id)
          .set({
            basket: basket,
            amount: paymentIntent.amount,
            created: paymentIntent.created,
          });

        setSucceeded(true);
        setError(null);
        setProcessing(false);

        /*dispatch({
          type: "EMPTY_BASKET",
          basket: [],
        });*/

        dispatch(emptyBasket());

        history.push("/orders");
      });
  };

  const handleChange = (event) => {
    //listen or changes in card element
    // and display any error as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  return (
    <div className="payment">
      <div className="payment__container">
        <h1>Checkout ({basket?.length} items)</h1>
        <div class="payment__section">
          <div className="payment__title">
            <h3>Delivery Address</h3>
          </div>
          <div className="payment__address">
            <p>{user?.email}</p>
            <p>Address Line 1</p>
            <p>City, District</p>
          </div>
        </div>
        <div class="payment__sectionProducts">
          <div className="payment__title">
            <h3>Review items and delivery</h3>
          </div>
          <div className="payment__items">
            {basket?.map((item) => (
              <CheckoutProduct
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                rating={item.rating}
              />
            ))}
          </div>
        </div>
        <div className="payment__cardDetails">
          <h3>Use Demo Card Details- 4242 4242 4242 4242 4242</h3>
          <p>Expiry- 04/24</p>
          <p>CVC- 242</p>
          <p>ZIP- 42424</p>
        </div>
        <div class="payment__section">
          <div className="payment__title">
            <h4>Payment Method</h4>
          </div>
          <div className="payment__details">
            <form onSubmit={handleSumit}>
              <CardElement onChange={handleChange} />
              <div className="payment__priceContainer">
                <CurrencyFormat
                  renderText={(value) => <h3>Order Total: {value}</h3>}
                  decimalScale={2}
                  value={getBasketTotal(basket)} //part of homework
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
                <button disabled={disabled || processing || succeeded}>
                  <span>{processing ? <p>Processing</p> : "Buy Now"}</span>
                </button>
              </div>
              {error && <div>{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;
